import React from "react";
import "./pageNotFound.scss";
import { errorImage } from "../../assets/images";
import { Link } from "react-router-dom";

export const PageNotFound = () => {
  return (
    <>
      <div className="wrapper_not_found">
        <div className="container">
          <div className="wrapper_text">
            <img src={errorImage} alt="error-image" />
            <h1>We are sorry, but the page you are looking for can not be found</h1>
            <div className="wrap_btn">
              <Link to="/" className="button blue">
                Go To Home Page
              </Link>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
